<template>
  <nav v-if="tileItems.length > 1" class="tile-container">
    <tile
      v-for="item in tileItems"
      v-bind:key="item.id"
      :preview-image-src="item.previewImageSrc"
      preview-image-alt="Blog"
      :route-name="item.routeName"
      :title="item.title"
      :route-parameters="item.routeParameters"
    >{{item.previewText}}</tile>
  </nav>
  <p class="no-items" v-else>There is no content here yet. Please check back soon, it's on the way!</p>
</template>

<script>
import tile from '@/components/navigation/tile'

export default {
  name: 'TileRepeater',
  components: {
    tile
  },
  props: {
    tileItems: {
      default () {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tile-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  column-gap: 15px;
  @media screen and (max-width: 762px) {
    display: block;
  }
}

.no-items {
  margin: 50px 0;
}

</style>
